import { PromoProps } from "@components/PromoBanner/common"
import breakpoints from "@constants/breakpoints"
import React from "react"
import styled from "styled-components"

import DesktopHeader from "./DesktopHeader"
import MobileHeader from "./MobileHeader"

const MobileContainer = styled.div`
  @media ${breakpoints.laptop} {
    display: none;
  }
`

const DesktopContainer = styled.div`
  display: none;
  @media ${breakpoints.laptop} {
    display: initial;
  }
`

interface HeaderProps {
  collapsePromoBanner?: boolean
  countdownTimer?: {
    eventEnd?: string
    eventStart: string
    textAfterEvent?: string
    textBeforeEvent: string
    textDuringEvent?: string
  }
  enterpriseLink: string
  expanded?: boolean
  filters?:
    | {}
    | {
        brand: {
          name: string
          slug: string
        }
        device: {
          device: {
            name: string
            slug: string
          }
          name: string
          slug: string
        }
      }
  FixedHeaderComponent?: React.ReactNode
  fixedHeaderTopRef?: any
  isLoggedIn?: boolean
  megaMenuActiveItem?: string
  megaMenuHeaderItems?: Array<{
    label: string
    onClick?: () => void
  }>
  megaMenuHeaderRef?: any
  onClickCart?: (e) => void
  onClickMenu?: (e) => void
  onClickSearch?: (e) => void
  onLogout?: () => void
  product?: object
  productCount?: number
  promos?: Array<PromoProps>
  promoScrollDelay: string
  rewardsPoints?: number
  searchValue?: string
  shortenDesktopHeader?: boolean
  showFilters?: boolean
  showFixedHeader?: boolean
  showPromoBanner?: boolean
  showRewardsPoints?: boolean
  supportLink: string
}

const Header = (props: HeaderProps) => {
  return (
    <>
      <DesktopContainer>
        <DesktopHeader {...props} />
      </DesktopContainer>
      <MobileContainer>
        <MobileHeader {...props} />
      </MobileContainer>
    </>
  )
}

export default Header
